import { motion } from "framer-motion";
import { FaInstagram, FaTiktok, FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { Logo } from "@/components/Logo";
import { assetUrl } from "@/lib/api";

export const Contact = ({ content }) => {
  const c = content.contact;
  const wa = `https://wa.me/${c.whatsapp}`;

  const SOCIALS = [
    { key: "whatsapp", label: "WhatsApp", handle: "Chat Sekarang", href: wa, Icon: FaWhatsapp, color: "from-green-500 to-green-600", shadow: "shadow-green-500/30" },
    { key: "instagram", label: "Instagram", handle: "@adhisatya_course", href: c.instagram, Icon: FaInstagram, color: "from-pink-500 via-rose-500 to-amber-500", shadow: "shadow-pink-500/30" },
    { key: "tiktok", label: "TikTok", handle: "@adhisatyacourse", href: c.tiktok, Icon: FaTiktok, color: "from-slate-800 to-black", shadow: "shadow-slate-800/30" },
    { key: "facebook", label: "Facebook", handle: "ADHISATYA COURSE", href: c.facebook, Icon: FaFacebookF, color: "from-blue-600 to-blue-700", shadow: "shadow-blue-600/30" },
  ];

  return (
    <section
      id="hubungi-kami"
      data-testid="contact-us-section"
      className="relative py-20 md:py-32 bg-gradient-to-br from-sky-600 via-sky-700 to-sky-900 overflow-hidden"
    >
      <div className="absolute inset-0 grid-pattern opacity-20" />
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-sky-400/20 rounded-full blur-3xl animate-blob" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-amber-400/10 rounded-full blur-3xl animate-blob" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-14"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur text-white text-sm font-semibold mb-5">
            Hubungi Kami
          </span>
          <h2 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tight leading-tight">
            Mari Terhubung & Mulai Belajar
          </h2>
          <p className="mt-5 text-lg text-sky-50/90 leading-relaxed">
            Punya pertanyaan atau ingin mendaftar? Hubungi kami melalui kanal berikut. Tim kami siap
            membantu Anda!
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {SOCIALS.map((s, i) => (
            <motion.a
              key={s.key}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Kunjungi ${s.label} ADHISATYA COURSE`}
              data-testid={`social-link-${s.key}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
              className="group p-7 rounded-3xl bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/15 hover:-translate-y-2 transition-all text-center"
            >
              <div className={`w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br ${s.color} flex items-center justify-center shadow-lg ${s.shadow} group-hover:scale-110 transition-transform`}>
                <s.Icon className="w-8 h-8 text-white" />
              </div>
              <div className="mt-5 text-lg font-bold text-white">{s.label}</div>
              <div className="mt-1 text-sm text-sky-100/80">{s.handle}</div>
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-14 text-center"
        >
          <a
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-main-cta"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-amber-400 hover:bg-amber-300 text-slate-900 font-bold text-lg shadow-xl shadow-amber-500/30 hover:-translate-y-1 transition-all"
          >
            <FaWhatsapp className="w-6 h-6" />
            Daftar via WhatsApp
          </a>
        </motion.div>
      </div>

      <footer className="relative mt-24 pt-10 border-t border-white/15">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Logo size={40} light logoUrl={assetUrl(content.brand.logo)} />
          <p className="text-sm text-sky-100/70 text-center">
            © {new Date().getFullYear()} {content.brand.name}. Semua hak cipta dilindungi.
          </p>
        </div>
      </footer>
    </section>
  );
};
